export default __webpack_public_path__ + "static/media/sun.7655f6b6.png";